import React, { useCallback, useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import MenuItemsTable from '../../MenuItemsTable/MenuItemsTable';
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {
  assignUnassignMenuItems,
  clearMenuItemsCatalog,
  clearProductGroupsCatalog,
  getCategories,
  getGroups,
  getGroupsCatalog,
  getMenuItemsCatalog,
  getMenuItemsFiltered,
} from '../../../redux/actions/platformsActions';
import {
  selectMenuItemsName,
  selectProductGroupsName,
} from '../../../redux/selectors/platformSelector';
import {
  ableAssignmentButton,
  closeAssignmentModalRestaurantsProducts,
} from '../../../redux/actions/utilsActions';
import { snackbarShowMessage } from '../../../redux/actions/snackbarActions';
import useStyles from '../constants/styles';
import { useTranslation } from 'react-i18next';
import { AppDispatch } from '../../../redux/store';

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

const AssignmentModalRestaurantsProducts = ({
  open,
  restaurantId,
  resetPlatforms,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const classes = useStyles();
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  const pagePlatforms = useSelector(
    (state: RootStateOrAny) => state.PlatformsReducer.page,
  );
  const groupsCatalog = useSelector((state: RootStateOrAny) =>
    selectProductGroupsName(state),
  );
  const itemsCatalog = useSelector((state: RootStateOrAny) =>
    selectMenuItemsName(state),
  );
  const restaurant = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );
  const [categories, setPlatforms] = useState<any[]>([]);
  const [totalPlatforms, setTotalPlatforms] = useState(0);
  const [groupsAll, setGroupsAll] = useState<any[]>([]);
  const [itemsAll, setItemsAll] = useState<any[]>([]);
  const [assign, setAssign] = useState<number>(0);
  const searchReduxObject = useSelector(
    (state: any) => state.EquipmentsReducer.searchObject,
  );
  const [groups, setGroups] = useState({});

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setAssign(newValue);
  };

  const fetchPlatforms = async (objSearch, clean = false) => {
    const result: any = await dispatch(getCategories(objSearch, false));
    const newCategories = result?.data?.['product-categories'] || [];
    if (clean) {
      setPlatforms(newCategories);
    } else {
      const copyPlatforms = [...categories, ...newCategories];
      setPlatforms([...copyPlatforms]);
    }
    setTotalPlatforms(result?.data?.pagination?.total || 0);
  };
  const fetchGroupsAll = async (objSearch, categoryId) => {
    const result: any = await dispatch(getGroups(objSearch, categoryId, false));
    const copyGroupsAll = [
      ...groupsAll,
      ...(result.data?.products?.length ? result.data.products : []),
    ];
    setGroupsAll([...copyGroupsAll]);
  };
  const fetchItemsAll = async objSearch => {
    const result: any = await dispatch(getMenuItemsFiltered(objSearch, false));
    const copyItemsAll = [
      ...itemsAll,
      ...(result.data?.menus?.length ? result.data.menus : []),
    ];
    setItemsAll([...copyItemsAll]);
  };

  useEffect(() => {
    if (groupsAll.length) {
      setGroups(
        groupsAll.reduce((ac, g: any) => {
          g.items = itemsAll.filter(
            (i: any) => i.productGroupId === g.productGroupId,
          );
          if (ac[g.categoryId]) {
            ac[g.categoryId].push(g);
          } else {
            ac[g.categoryId] = [g];
          }
          return ac;
        }, {}),
      );
    } else {
      setGroups({});
    }
  }, [groupsAll, itemsAll]);

  const [searchObjectPrev, setSearchObjectPrev] = useState<any>({
    group: '',
    item: '',
  });
  const [searchObject, setSearchObject] = useState<any>({
    group: '',
    item: '',
  });
  const handleChangeAutocomplete = (name: string, value: any) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      [name]: value ? value : '',
    });
  };
  const [itemInput, setItemInput] = useState<string>('');
  const [timer, setTimer] = useState<any>(null);
  const callBackFunctionItems = useCallback(
    value => {
      clearTimeout(timer);
      if (itemInput !== value && value.length > 2) {
        setItemInput(value);
        setTimer(
          setTimeout(
            () =>
              dispatch(
                getMenuItemsCatalog(selectedBrand, value, 0, {
                  regions: `["${restaurant.Region}"]`,
                  countries: `[${restaurant.CountryId}]`,
                }),
              ),
            500,
          ),
        );
      } else if (!value) {
        setItemInput(value);
        dispatch(clearMenuItemsCatalog());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [timer, setItemInput, setTimer],
  );
  const [groupInput, setGroupInput] = useState<string>('');
  const [timerGroup, setTimerGroup] = useState<any>(null);
  const callBackFunctionGroups = useCallback(
    value => {
      clearTimeout(timerGroup);
      if (groupInput !== value && value.length > 2) {
        setGroupInput(value);
        setTimerGroup(
          setTimeout(
            () =>
              dispatch(
                getGroupsCatalog(selectedBrand, value, 0, {
                  regions: `["${restaurant.Region}"]`,
                  countries: `[${restaurant.CountryId}]`,
                }),
              ),
            500,
          ),
        );
      } else if (!value) {
        setGroupInput(value);
        dispatch(clearProductGroupsCatalog());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [timerGroup, groupInput, selectedBrand],
  );
  const handleInputChangeAutocomplete = (name: string, value: any) => {
    switch (name) {
      case 'item':
        callBackFunctionItems(value);
        break;
      case 'group':
        callBackFunctionGroups(value);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    fetchPlatforms({
      brand: restaurant.brand,
      regions: `["${restaurant.Region}"]`,
      countries: `[${restaurant.CountryId}]`,
      limit: 100,
    });
  }, [restaurant]);

  const handleApplyButton = () => {
    setSearchObject({ ...searchObjectPrev });
    const objSearch = {
      productGroupId: searchObjectPrev.group?.productGroupId,
      menuItem: searchObjectPrev.item?.id,
    };
    fetchPlatforms(
      {
        ...searchReduxObject,
        ...objSearch,
        brand: restaurant.brand,
        regions: `["${restaurant.Region}"]`,
        countries: `[${restaurant.CountryId}]`,
        limit: 100,
      },
      true,
    );
    setGroupsAll([]);

    if (
      objSearch.productGroupId ||
      objSearch.menuItem ||
      searchReduxObject.countries ||
      searchReduxObject.regions
    ) {
      setItemsAll([]);
    }
  };

  const loadMorePlatforms = () => {
    const objSearch = {
      productGroupId: searchObjectPrev.group?.productGroupId,
      menuItem: searchObjectPrev.item?.id,
    };
    fetchPlatforms({
      ...searchReduxObject,
      ...objSearch,
      brand: restaurant.brand,
      regions: `["${restaurant.Region}"]`,
      countries: `[${restaurant.CountryId}]`,
      limit: 100,
      page: pagePlatforms + 1,
    });
  };

  const loadMoreGroups = (categoryId, page) => () => {
    const objSearch = {
      productGroupId: searchObjectPrev.group?.productGroupId,
      menuItem: searchObjectPrev.item?.id,
    };
    fetchGroupsAll(
      {
        ...searchReduxObject,
        ...objSearch,
        brand: restaurant.brand,
        regions: `["${restaurant.Region}"]`,
        countries: `[${restaurant.CountryId}]`,
        limit: 100,
        page: page + 1,
      },
      categoryId,
    );
  };

  const loadMoreItems = (category, productGroup, page) => () => {
    const categoryId =
      groupsAll.find(group => group.categoryId === category)?.categoryId || 0;
    const objSearch = {
      productGroupId: productGroup,
      menuItem: searchObjectPrev.item?.id,
      categoryId,
    };
    fetchItemsAll({
      ...searchReduxObject,
      ...objSearch,
      brand: restaurant.brand,
      regions: `["${restaurant.Region}"]`,
      countries: `[${restaurant.CountryId}]`,
      limit: 100,
      page: page + 1,
    });
  };

  const fetchGroups = id => {
    const objSearch = {
      productGroupId: searchObject.group?.productGroupId,
      menuItem: searchObject.item?.id,
    };
    fetchGroupsAll(
      {
        ...searchReduxObject,
        ...objSearch,
        brand: restaurant.brand,
        regions: `["${restaurant.Region}"]`,
        countries: `[${restaurant.CountryId}]`,
        limit: 100,
      },
      id,
    );
  };

  const fetchItems = idGroup => {
    const categoryId =
      groupsAll.find(group => group.productGroupId === idGroup)?.categoryId ||
      0;
    const objSearch = {
      productGroupId: searchObject.group?.productGroupId || idGroup,
      menuItem: searchObject.item?.id,
      categoryId,
    };
    fetchItemsAll({
      ...searchReduxObject,
      ...objSearch,
      brand: restaurant.brand,
      regions: `["${restaurant.Region}"]`,
      countries: `[${restaurant.CountryId}]`,
      limit: 100,
    });
  };
  const [itemsSelected, setItemsSelected] = useState({
    categories: [],
    groups: [],
    menu_items: [],
  });
  const checkSelected = selectedRows => {
    setItemsSelected({ ...selectedRows });
  };
  const [clearFlag, setClearFlag] = useState(false);

  const clearSelectedEquipments = flag => {
    setClearFlag(flag);
  };

  const closeModal = () => {
    dispatch(closeAssignmentModalRestaurantsProducts());
    dispatch(ableAssignmentButton());
  };

  const assignUnassignToRestaurants = async () => {
    const objToAssign = {
      reporting_unit: 0,
      restaurants: [Number(restaurantId)],
      assign: !assign,
      brand: selectedBrand,
    };
    if (itemsSelected.categories?.length) {
      objToAssign['categories'] = itemsSelected.categories.map(category =>
        Number(category),
      );
    }
    if (itemsSelected.groups?.length) {
      objToAssign['groups'] = itemsSelected.groups;
    }
    if (itemsSelected.menu_items?.length) {
      objToAssign['menu_items'] = itemsSelected.menu_items;
    }
    if (restaurant?.CountryId) {
      objToAssign['countries'] = [Number(restaurant.CountryId)];
    }
    if (restaurant?.Region) {
      objToAssign['regions'] = restaurant.Region.replace(
        /[\[\]\%22]/g,
        '',
      ).split(',');
    }

    const response: any = await dispatch(assignUnassignMenuItems(objToAssign));
    if (response?.status === 200) {
      dispatch(
        snackbarShowMessage(
          !assign
            ? 'menuItems.messages.assignSuccess'
            : 'menuItems.messages.unassignSuccess',
        ),
      );
      resetPlatforms();
    } else {
      dispatch(
        snackbarShowMessage(
          !assign
            ? 'menuItems.messages.assignError'
            : 'menuItems.message.unassignError',
        ),
      );
    }
    clearSelectedEquipments(true);
    closeModal();
  };

  const clearFilters = () => {
    setSearchObjectPrev({
      group: '',
      item: '',
    });
    setSearchObject({
      group: '',
      item: '',
    });
    fetchPlatforms({
      brand: restaurant.brand,
      regions: `["${restaurant.Region}"]`,
      countries: `[${restaurant.CountryId}]`,
      limit: 100,
    });
    setGroupsAll([]);
    setItemsAll([]);
    dispatch(clearMenuItemsCatalog());
    dispatch(clearProductGroupsCatalog());
  };

  const { t } = useTranslation();

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={closeModal}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      maxWidth="md"
    >
      <DialogContent className={classes.dialogContent}>
        <div className={classes.tabBackground}>
          <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
            <div className={classes.divItems}>
              <Typography variant="body1" style={{ fontWeight: 600 }}>
                {t('restaurant.assignments')}
              </Typography>
              <IconButton
                style={{ position: 'relative', left: '40px', paddingTop: 0 }}
                onClick={closeModal}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <AppBar
            elevation={0}
            position="static"
            color="primary"
            className={classes.appBar}
          >
            <Tabs
              value={assign}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
              className={classes.tabs}
              TabIndicatorProps={{
                style: {
                  display: 'none',
                },
              }}
            >
              <Tab
                className={
                  !assign ? classes.tabSelected : classes.tabNotSelected
                }
                label={t('home.assignment.assign')}
                {...a11yProps(0)}
              />
              <Tab
                className={
                  assign ? classes.tabSelected : classes.tabNotSelected
                }
                label={t('home.assignment.unassign')}
                {...a11yProps(1)}
              />
            </Tabs>
          </AppBar>
          <div className={classes.tabPanel}>
            <TabPanel value={1} index={1}>
              <MenuItemsTable
                categories={categories}
                groups={groups}
                showDetailProduct={() => {}}
                searchObjectPrev={searchObjectPrev}
                handleInputChangeAutocomplete={handleInputChangeAutocomplete}
                handleChangeAutocomplete={handleChangeAutocomplete}
                handleApplyButton={handleApplyButton}
                fetchItems={fetchItems}
                groupsCatalog={groupsCatalog}
                itemsCatalog={itemsCatalog}
                fetchGroups={fetchGroups}
                totalPlatforms={totalPlatforms}
                loadMorePlatforms={loadMorePlatforms}
                loadMoreGroups={loadMoreGroups}
                loadMoreItems={loadMoreItems}
                handleApply={handleApplyButton}
                checkSelected={checkSelected}
                clearFlag={clearFlag}
                clearSelectedEquipments={clearSelectedEquipments}
                showProductGroupTranslations={() => {}}
                withNormalOptions={false}
                clearFilters={clearFilters}
              />
            </TabPanel>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} variant="contained" color="primary">
          {t('app.common.cancel')}
        </Button>
        <Button
          onClick={assignUnassignToRestaurants}
          variant="contained"
          color="primary"
          disabled={
            !itemsSelected.categories.length &&
            !itemsSelected.groups.length &&
            !itemsSelected.menu_items.length
          }
        >
          {assign ? t('home.assignment.unassign') : t('home.assignment.assign')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignmentModalRestaurantsProducts;
